/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "../models";

import * as questionIds from "./questionIds";

const section10MedicalTypes = [MedicalTypeIds.HAVS];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 */
export const section10Questions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.UseVibratingTools,
        questionText: "Do you use vibrating tools at work?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.UseVibratingToolsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.VibratingToolsLast12Months,
        questionText: "Have you stopped using vibrating tools in the last 12 months?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.VibratingToolsLast12MonthsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.YearsUsingVibratingTools,
        questionText: "How many years have you used vibrating tools or equipment?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.MonthsUsingVibratingToolsLastYear,
        questionText: "How many months in total have you used vibrating tools in the last year?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HoursPerWeekUsingVibratingTools,
        questionText: "How many hours a week do you use these tools?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.SeasonUsingVibratingToolsMost,
        questionText: "Do you use vibrating tools more in the winter or summer?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.WhichHandFeelsMostVibration,
        questionText: "In which hand do you use notice the vibration most?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.LeftRightHanded,
        questionText: "Are you left or right handed?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.ProblemsWithHandsOrArms,
        questionText: "Are you experiencing any problems with your hands or arms such as pain, swelling, deformity or weakness?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.ProblemsWithHandsOrArmsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.EverNeckArmHandInjury,
        questionText: "Have you ever had a neck/arm/hand injury?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.EverNeckArmHandInjuryFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.SeriousDiseaseJointsNervesHeatBloodVessels,
        questionText: "Do you have any serious disease of the joints/nerves/heart/or blood vessels? ",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.SeriousDiseaseJointsNervesHeatBloodVesselsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HavsReceivingTreatment,
        questionText: "Are you on any medication or receiving any treatment from your doctor or other health professional?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HavsReceivingTreatmentFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HavsDoYouSmoke,
        questionText: "Do you smoke?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HavsDoYouSmokeFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HavsEverSmoked,
        questionText: "Have you ever smoked?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HavsEverSmokedWhenStopped,
        questionText: "When did you stop?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HavsDrinkAlcohol,
        questionText: "Do you drink alcohol?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HavsDrinkAlcoholNumberUnitsPerWeek,
        questionText: "How much do you drink, in units per week? 1 unit = half a pint of beer or single glass of wine or measure of spirit.",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HobbiesExposeToVibrations,
        questionText: "Do any of your hobbies expose you to hand/arm vibration e.g. motorcycles, power tools etc.",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HobbiesExposeToVibrationsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.FamilyVibrationWhiteFinger,
        questionText: "Has anyone in your family suffered from vibration white finger?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.FamilyVibrationWhiteFingerWho,
        questionText: "Who?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.FingersGoneWhiteInCold,
        questionText: "Do/have your fingers go/gone white in the cold?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.FingersGoneWhiteInColdLastYear,
        questionText: "Has this happened in the last year?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.DifficultyWarmingFingers,
        questionText: "Do you have difficulty making your fingers warm again when leaving the cold?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.ContinuousDifficultyWarmingFingers,
        questionText: "Is it continuous or only some of the time?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.WhenDifficultyWarmingFingers,
        questionText: "When does it occur?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.FingersGoneWhiteInColdFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.TinglingFingers,
        questionText: "Do you suffer from tingling in your fingers?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.TinglingFingersFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.TinglingFingersWhilstWorking,
        questionText: "Does this occur whilst you are working?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.TinglingFingersWhilstWorkingFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.TinglingFingersInResponseToCold,
        questionText: "Does this occur in response to the cold?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.TinglingFingersInResponseToColdFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.TinglingFingersOccurOtherTimes,
        questionText: "Does the tingling occur at other times",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.TinglingFingersOccurOtherTimesFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.TinglingFingersAtNight,
        questionText: "At night or disturb your sleep?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.TinglingFingersAtNightFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.TinglingForearm,
        questionText: "Do you have any tingling or pain in your forearm?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.TinglingForearmFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HistoryOfBalanceCondition,
        questionText: "Do you have any history of any condition that affects balance?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HistoryOfBalanceConditionFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.HowLongHadTingling,
        questionText: "How long have you had tingling in your fingers or arm?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.FingersGoNumb,
        questionText: "Do your fingers go numb?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.FingersGoNumbWhen,
        questionText: "When do you experience this",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.FingersGoNumbFirstNoticed,
        questionText: "When did you first notice the numbness?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.DifficultyWithFineMovements,
        questionText: "Do you have any difficulty with fine movements of your finger e.g. fastening your buttons, picking up small nuts and bolts?",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.DifficultyWithFineMovementsLeftHandSymptoms,
        questionText: "Please state which symptoms you experience in your left hand",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.DifficultyWithFineMovementsRightHandSymptoms,
        questionText: "Please state which symptoms you experience in your right hand",
        medicalTypes: section10MedicalTypes
    },
    {
        id: questionIds.ReportedDifficultyWithFineMovementSymptoms,
        questionText: "Have you reported these symptoms to your employer?",
        medicalTypes: section10MedicalTypes
    }
];
/* eslint-enable max-len */

export const NumberYearsVibratingToolsOptions = [
    { text: "0-5 Years", value: "0To5Years" },
    { text: "5-10 Years", value: "5To10Years" },
    { text: "10+ Years", value: "10PlusYears" }
];

export const MonthsUsingVibratingToolsLastYearOptions = [
    { text: "0-4 Months", value: "0To4Months" },
    { text: "4-8 Months", value: "4To8Months" },
    { text: "8-12 Months", value: "8To12Months" }
];

export const HoursPerWeekUsingVibratingToolsOptions = [
    { text: "Less than 5 hours", value: "Less5Hours" },
    { text: "5-10 hours", value: "5To10Hours" },
    { text: "10-20 hours", value: "10To20Hours" }
];

export const SeasonUsingVibratingToolsMostOptions = [
    { text: "Winter", value: "Winter" },
    { text: "Summer", value: "Summer" }
];

export const LeftRightHandOptions = [
    { text: "Right", value: "Right" },
    { text: "Left", value: "Left" }
];

export const FingersGoNumbWhenOptions = [
    { text: "Working", value: "Working" },
    { text: "In response to cold", value: "ResponseToCold" },
    { text: "When your fingers go white (blanch)", value: "WhenFingersGoWhite" }
];

export const DifficultyWithFineMovementsSymptomsOptions = [
    { text: "Blanching (white fingers)", value: "Blanching" },
    { text: "Tingling", value: "Tingling" },
    { text: "Numbness", value: "Numbness" }
];
